module.exports = __webpack_public_path__ + "static/img/tiktok_blue.a00bf880.png";